import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { all, put, call, takeEvery } from 'redux-saga/effects';
import get from 'lodash/get';
import { Url, URLS, USER_PROFILE_POSTS_SUB_PATHS } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { convertToServerXhrPayload } from '../../DaEditorWrapper/utils';
import { request } from '../../xhr';
import { normalize } from '../../redux/normalizr';
import { putEntities } from '../../redux/entities/actions';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { editDeviationSuccess } from '../../redux/deviations/actionCreators';
import { logBiEvent } from '../../biLogger/redux/saga';
import { ResourceType } from '../../types/resource';
import { WriterPopupType } from './types';
import { publishWriterDeviation, saveWriterDeviation, saveWriterDeviationSuccess, saveWriterDeviationFailure, setIsRedirecting } from './actions';
import { convertResponseErrorToWriterError, fakeResponse, getWriterEndpoint } from './utils';
import { PureBiData } from '@wix/da-bi/pkg/events';
const logger = ddt.createLogger('writer.saga');
function* dispatchSaveWriterDeviationFailure(response) {
    var _response;
    yield put(saveWriterDeviationFailure(convertResponseErrorToWriterError((_response = response) === null || _response === void 0 ? void 0 : _response.errorDetails)));
}
function* doCreateWriterDeviation(type, groupId, localState) {
    var _coverImage, _editorState, _editorState1, _editorState2;
    const { journalTitle: title = '', editorState, coverImage } = localState;
    logger.log('doCreateWriterDeviation', {
        type,
        groupId,
        localState
    });
    return yield call(request, {
        method: 'post',
        url: getWriterEndpoint('/create', type),
        data: _object_spread({
            title,
            group_id: groupId,
            cover_image_deviation_id: (_coverImage = coverImage) === null || _coverImage === void 0 ? void 0 : _coverImage.deviationId
        }, convertToServerXhrPayload((_editorState = editorState) === null || _editorState === void 0 ? void 0 : _editorState.rawContentState, (_editorState1 = editorState) === null || _editorState1 === void 0 ? void 0 : _editorState1.editorContent, (_editorState2 = editorState) === null || _editorState2 === void 0 ? void 0 : _editorState2.features))
    }, fakeResponse);
}
function* doUpdateWriterDeviation(type, groupId, deviation, localState) {
    var _deviation, _coverImage, _editorState, _editorState1, _editorState2, _result, _deviation1, _localState_visibility;
    const { journalTitle: title = '', editorState, coverImage } = localState;
    logger.log('doUpdateWriterDeviation', {
        type,
        groupId,
        deviation,
        localState
    });
    const result = yield call(request, {
        method: 'post',
        url: getWriterEndpoint('/update/content', type),
        data: _object_spread({
            title,
            group_id: groupId,
            deviationid: (_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.deviationId,
            cover_image_deviation_id: (_coverImage = coverImage) === null || _coverImage === void 0 ? void 0 : _coverImage.deviationId
        }, convertToServerXhrPayload((_editorState = editorState) === null || _editorState === void 0 ? void 0 : _editorState.rawContentState, (_editorState1 = editorState) === null || _editorState1 === void 0 ? void 0 : _editorState1.editorContent, (_editorState2 = editorState) === null || _editorState2 === void 0 ? void 0 : _editorState2.features))
    }, fakeResponse);
    if (!((_result = result) === null || _result === void 0 ? void 0 : _result.deviation)) {
        logger.log('failure', result);
        return result;
    }
    if (type === WriterPopupType.LITERATURE) {
        return result;
    }
    return yield call(request, {
        method: 'post',
        url: getWriterEndpoint('/update/metadata', type),
        data: {
            deviationid: (_deviation1 = deviation) === null || _deviation1 === void 0 ? void 0 : _deviation1.deviationId,
            group_id: groupId,
            featured: localState.isFeaturedPost,
            // TODO: Uncomment this and replace it with the real mature param
            // mature: localState.isMaturePost,
            tiers: ((_localState_visibility = localState.visibility) === null || _localState_visibility === void 0 ? void 0 : _localState_visibility.type) === 'tier' ? localState.visibility.tiers.map((tier)=>tier.deviationId) : undefined
        }
    }, fakeResponse);
}
/** Sends a request to our create or update endpoint depending on if the provided deviation exists */ function* doCreateOrUpdateDeviation(type, groupId, deviation, localState) {
    var _deviation, _result;
    let result = null;
    if (((_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.deviationId) === undefined) {
        result = yield call(doCreateWriterDeviation, type, groupId, localState);
    } else {
        result = yield call(doUpdateWriterDeviation, type, groupId, deviation, localState);
    }
    if (result && ((_result = result) === null || _result === void 0 ? void 0 : _result.deviation)) {
        var _result1, _deviation1;
        yield call(handleSuccess, {
            deviation: (_result1 = result) === null || _result1 === void 0 ? void 0 : _result1.deviation,
            type
        }, ((_deviation1 = deviation) === null || _deviation1 === void 0 ? void 0 : _deviation1.deviationId) !== undefined);
    } else {
        yield call(dispatchSaveWriterDeviationFailure, result);
    }
    return result;
}
function* handleSuccess({ deviation, type }, wasEdit = false) {
    const { result: deviationId, entities } = normalize(deviation, deviationSchema);
    const resultActions = [
        put(putEntities({
            entities
        })),
        // Even though deviationId is expected to be a number and we're passing through the normalized
        // deviation id (which could be number | string), it should only ever receive
        // a deviation that production an id of type number
        put(saveWriterDeviationSuccess({
            deviationId,
            type
        }))
    ];
    if (wasEdit) {
        resultActions.push(put(editDeviationSuccess({
            deviation
        })));
    }
    yield all(resultActions);
    logger.log('success', deviationId);
}
function* handleRedirect(url) {
    logger.log('redirect', url);
    window.location.assign(url);
}
function* handleSaveWriterDeviation(action) {
    var _result;
    // need to call "setIsRedirecting" before "doCommonSaveResultCleanup" to have a smooth
    // transition from isSubmitting to isRedirecting
    yield put(setIsRedirecting({
        isRedirecting: true
    }));
    const { type, deviation, groupId, localState } = action.payload;
    const result = yield call(doCreateOrUpdateDeviation, type, groupId, deviation, localState);
    if ((_result = result) === null || _result === void 0 ? void 0 : _result.deviation) {
        var _result_deviation_author;
        // Upon successful submission, we should redirect to Posts/Drafts tab if unpublished,
        // browse posts feed if it is published
        const authorName = ((_result_deviation_author = result.deviation.author) === null || _result_deviation_author === void 0 ? void 0 : _result_deviation_author.username) || '';
        let redirectTo = result.deviation.isPublished ? getDeviationUrl(result.deviation) : Url.userPostsLink({
            username: authorName,
            subPath: USER_PROFILE_POSTS_SUB_PATHS.DRAFTS
        });
        if (type === WriterPopupType.LITERATURE) {
            var _deviation;
            // Saving a Literature draft should redirect to the sta.sh draft folder
            // but since we do not know the drafts folder hash (yet to be implemented
            // on the backend) we should redirect to the sta.sh root
            redirectTo = Url.buildFromPath(URLS.STASH);
            // If its published we need to redirect back to submit not stash
            if ((_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.isPublished) {
                redirectTo = `${Url.buildFromPath(URLS.SUBMIT)}?deviationids=${deviation.deviationId}`;
            }
        }
        yield call(handleRedirect, redirectTo);
    } else {
        yield put(setIsRedirecting({
            isRedirecting: false
        }));
    }
}
function* handlePublishWriterDeviation(action) {
    var _localState_visibility;
    const { type, groupId, refreshAfterSubmit, deviation, localState } = action.payload;
    logger.log('publishWriterDeviation', action.payload);
    // need to call "setIsRedirecting" before any save/publish requests to have a smooth
    // transition from isSubmitting to isRedirecting
    yield put(setIsRedirecting({
        isRedirecting: true
    }));
    const saveResult = yield call(doCreateOrUpdateDeviation, type, groupId, deviation, localState);
    if (!saveResult || !saveResult.deviation) {
        if (saveResult && saveResult.errorCode === 302) {
            window.location.replace(saveResult.errorDetails.redirectUrl);
        }
        yield call(dispatchSaveWriterDeviationFailure, saveResult);
        return;
    }
    const deviationid = get(saveResult.deviation, 'deviationId', null);
    if (type === WriterPopupType.LITERATURE) {
        var _deviation;
        // Literature submission should finalize on the legacy submit page
        if (!((_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.isPublished)) {
            yield call(logBiEvent, PureBiData({
                evid: 11,
                group_exclusive: groupId !== undefined,
                typeid: ResourceType.DEVIATION,
                itemid: deviationid
            }));
        }
        yield call(handleRedirect, `${Url.buildFromPath(URLS.SUBMIT)}?deviationids=${deviationid}`);
        return;
    }
    const result = yield call(request, {
        method: 'post',
        url: getWriterEndpoint('/publish', type),
        data: {
            deviationid,
            featured: localState.isFeaturedPost,
            // TODO: Uncomment this and replace it with the real mature param
            // mature: localState.isMaturePost,
            group_id: groupId,
            tiers: ((_localState_visibility = localState.visibility) === null || _localState_visibility === void 0 ? void 0 : _localState_visibility.type) === 'tier' ? localState.visibility.tiers.map((tier)=>tier.deviationId) : undefined
        }
    }, fakeResponse);
    logger.log('response', result);
    if (result && result.deviation) {
        const returnedDeviation = result.deviation;
        yield call(logBiEvent, PureBiData({
            evid: 11,
            group_exclusive: groupId !== undefined,
            typeid: ResourceType.JOURNAL,
            itemid: returnedDeviation.deviationId
        }));
        yield call(handleSuccess, {
            deviation: returnedDeviation,
            type
        });
        // Upon successful submission, we should redirect
        if (refreshAfterSubmit) {
            window.location.reload();
        } else {
            yield call(handleRedirect, getDeviationUrl(returnedDeviation));
        }
    } else {
        yield put(setIsRedirecting({
            isRedirecting: false
        }));
        yield call(dispatchSaveWriterDeviationFailure, result);
    }
}
function* handleSaveWriterDeviationFailure(action) {
    logger.log('failure', action.payload.error);
}
export default function* saga() {
    yield all([
        takeEvery(saveWriterDeviation, handleSaveWriterDeviation),
        takeEvery(publishWriterDeviation, handlePublishWriterDeviation),
        takeEvery(saveWriterDeviationFailure, handleSaveWriterDeviationFailure)
    ]);
}
